import e from "./index210.mjs";
import d from "./index298.mjs";
import m from "./index212.mjs";
function s(r, o) {
  m(2, arguments);
  var t = e(o);
  return d(r, t * 1e3);
}
export {
  s as default
};
//# sourceMappingURL=index245.mjs.map
